import { DocumentRequestEventNameEnum } from '../enums/document-request-event-name.enum';

export const DocumentRequestEventNameLabel = {
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_CREATED]: 'Request created',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SEEN_BY_CANDIDATE]:
    'Request seen by candidate',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_READY_TO_REVIEW]:
    'Request ready to review',
  [DocumentRequestEventNameEnum.DOCUMENT_SEND_TO_SUBSCRIPTION_SUCCESS]:
    'Successfully sent to the server',
  [DocumentRequestEventNameEnum.DOCUMENT_SEND_TO_SUBSCRIPTION_FAIL]:
    'Error when trying to send to the server',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_APPROVED]: 'Request approved',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_CANCELED]: 'Request canceled',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_DELETED]: 'Request purged',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_RESULT_DOWNLOADED]:
    'Request result downloaded',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUESTED]: 'Requested',
  [DocumentRequestEventNameEnum.DOCUMENT_UPLOADED]: 'Submitted',
  [DocumentRequestEventNameEnum.DOCUMENT_APPROVED]: 'Approved',
  [DocumentRequestEventNameEnum.DOCUMENT_REJECTED]: 'Rejected',
  [DocumentRequestEventNameEnum.DOCUMENT_DELETED]: 'Purged',
  [DocumentRequestEventNameEnum.DOCUMENT_ARCHIVED]: 'Archived',
  [DocumentRequestEventNameEnum.DOCUMENT_DETAILS_UPDATED]: 'Details updated',
  [DocumentRequestEventNameEnum.DOT_MEDICAL_VERIFICATION_FILE_UPLOADED]:
    'Dot medical verification file uploaded',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_STATUS_CHANGED]:
    'SMS delivery status:',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_DELIVERED]:
    'SMS delivered:',
  [DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_ERROR]: 'SMS error:',
  [DocumentRequestEventNameEnum.DOCUMENT_APPROVED_SMS_STATUS_FAILED]:
    'SMS failed:',
  [DocumentRequestEventNameEnum.DOCUMENT_APPROVED_SMS_STATUS_DELIVERED]:
    'SMS delivered:',
};
